import React from 'react';

export const FileListHeader = () => (
  <div className="flex items-center justify-between font-medium uppercase text-foreground-muted">
    <div className="w-[35%]">DOCUMENT NAME</div>
    <div className="w-[30%] text-left">STATUS</div>
    <div className="w-[35%] text-right">Ready to be signed</div>
  </div>
);
